<template>
    <div class="container" style="padding-top: 10px" v-show="shop.id">
        <div class="el-card box-card is-always-shadow">
            <div class="el-card__header">
                <div class="clearfix">
                    <span>Ordenes por Cuotas</span>
                </div>
            </div>
            <form
                :model="form"
                label-width="120px"
                @submit.prevent="onSubmit"
                enctype="multipart/form-data"
            >
                <div class="el-card__body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group text-left">
                                <label> Archivo</label>
                                <input
                                    type="file"
                                    id="file"
                                    ref="file"
                                    class="form-control"
                                    v-on:change="handleFileUpload()"
                                    v-validate="'required'"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <el-button type="danger" @click="resetForm"
                            >Cancelar</el-button
                        >
                        <el-button
                            type="primary"
                            @click="onSubmit"
                            :icon="isLoading ? 'el-icon-loading' : ''"
                            :disabled="isLoading"
                        >
                            Continuar
                        </el-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "pending-orders-add",
    components: {},
    data() {
        return {
            respomse: {
                request: {
                    file: "",
                },
            },
            shop: {},
            balance: 0,
            dayTotal: 0,
            avatar: "https://via.placeholder.com/150",
            form: {
                file: "",
                shop_id: 0,
            },
            isLoading: false,
            labels: {
                file: "Archivo",
            },
        };
    },
    async created() {
        this.getShops();
    },
    methods: {
        handleFileUpload() {
            this.form.file = this.$refs.file.files[0];
        },
        async onSubmit() {
            this.isLoading = true;
            if (!this.shop.id) {
                this.isLoading = false;
                return;
            }

            //const formData = Object.entries(this.form);
            //console.log(this.form);
            //   if (!this.form.file) {
            //     this.$notify({
            //       title: "Error",
            //       message: `el campo: Archivo es requerido`,
            //       type: "error",
            //     });
            //     this.isLoading = false;
            //     return;
            //   }

            let formData = new FormData();

            formData.append("file", this.form.file);
            formData.append("shop_id", this.form.shop_id);

            axios
                .post(`${API_URL}/orders/requests-csv`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    window.location.replace("/pending-orders");
                })
                .catch((error) => {
                    var message = error.response.data.status.message;
                    this.$notify({
                        title: "Error",
                        message: message,
                        type: "error",
                    });
                    this.isLoading = false;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getShops() {
            this.shop = this.$store.state.user;
            this.form.shop_id = this.$store.state.user.id;
        },
        resetForm() {
            window.location.replace("/pending-orders");
        },
    },
};
</script>
